import { faqItems } from '@/mocks/homepage';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500">
            关于哔咔动漫，你可能想了解的一切
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-8">
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-secondary-100 text-secondary-600 group-open:bg-primary-100 group-open:text-primary-600 transition-colors duration-200">
                  <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform duration-200"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}